import React from "react";

import { FooterMenuTypes } from "../../../types/layout";

import useWindowDimensions from "../../../hooks/useWindowDimensions";

import MENU_PATHS from "../../../constants/menu";

import LinkContainer from "./LinkContainer";
import SocialInfo from "./SocialInfo";
import ContactInfo from "./ContactInfo";

// TODO:: add paths for Join section
const linksData: FooterMenuTypes[] = [
  {
    id: 1,
    title: "Site map",
    links: [
      { id: 1, name: "Home", path: MENU_PATHS.HOMEPAGE },
      { id: 2, name: "Team", path: MENU_PATHS.TEAM },
      { id: 3, name: "News", path: MENU_PATHS.NEWS },
      { id: 4, name: "Contact us", path: MENU_PATHS.CONTACT },
    ],
  },
  {
    id: 2,
    title: "Join",
    links: [
      {
        id: 1,
        name: "I Am Dive Team Member",
        path: MENU_PATHS.DIVE_TEAM_MEMBERS,
      },
      {
        id: 2,
        name: "I Am A Diving Organization",
        path: MENU_PATHS.DIVING_ORGANIZATIONS,
      },
      {
        id: 3,
        name: "I Am A Diving End Client",
        path: MENU_PATHS.CLIENT_ORGANIZATIONS,
      },
      { id: 4, name: "I Am A Dive School", path: MENU_PATHS.DIVE_SCHOOLS },
      {
        id: 5,
        name: "I Am A Trade Organization / Agency",
        path: MENU_PATHS.ADVERTISING_AND_MARKETING,
      },
    ],
  },
];

const FooterInfo = () => {
  const { isSmallScreen } = useWindowDimensions();
  return (
    <div className="m-footer__footerInfo _12 -gap10">
      <SocialInfo />

      {!isSmallScreen &&
        linksData.map(({ id, title, links }) => (
          <LinkContainer key={id} title={title} links={links} />
        ))}

      <ContactInfo />
    </div>
  );
};

export default FooterInfo;
